WiseMetering.Views.NewMeasurablIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/measurabl/new',
    title: () => i18next.t('modal.title.integrations.new'),

    ui: {
        sites: '#site_id',
        configurations: '#integration_configuration_id',
        indicators: '#integration_indicator_id',
        startSyncAt: '#integration_start_sync_at'
    },

    events: {
        'change @ui.sites': 'onSiteChange'
    },

    afterSave: function() {
        WiseMetering.indicators.fetch();
    },

    getFormData: function() {
        const data = this.formSerializer();
        data.partner_id = this.options.license.get('partner_id');
        return data;
    },

    onSiteChange: function() {
        const selectedSiteId = this.ui.sites.val();

        if (!selectedSiteId) {
            this.ui.configurations.empty();
            this.ui.indicators.empty();
            return;
        }

        const
            usedIndicatorsIds = this.model.license().indicators().pluck('id'),
            availableIndicators = WiseMetering.indicators.utilityIndicators().models.filter(indicator => !usedIndicatorsIds.includes(indicator.id) && indicator.get('site_id') === selectedSiteId),
            indicators = WiseMetering.utils.optionsFromModels(availableIndicators, 'name', null, availableIndicators.length !== 1),
            configurations = WiseMetering.integrationConfigurations.where({ site_id: selectedSiteId, license_id: this.model.license().id }),
            configurationOptions = WiseMetering.utils.optionsFromModels(configurations, 'name', null, configurations.length !== 1);

        this.ui.indicators.html(indicators);
        this.ui.configurations.html(configurationOptions);
    },

    onRender: function() {
        const maxRetention = WiseMetering.currentOrganization.plan().get('data_retention');

        this.ui.startSyncAt.datepicker({
            dateFormat: 'yy-mm-dd',
            changeDay: true,
            changeMonth: true,
            changeYear: true,
            maxDate: moment().endOf('year').format('YYYY-MM-DD'),
            minDate: moment().add(-maxRetention, 'years').startOf('year').format('YYYY-MM-DD')
        });
    },

    onShow: function() {
        const
            sitesWithConfigurations = this.model.license().configurations().pluck('site_id'),
            sites = WiseMetering.zones.activeSites().models.filter(site => sitesWithConfigurations.includes(site.id));

        this.ui.sites.html(WiseMetering.utils.optionsFromModels(sites, 'name', null, sites.length !== 1));
        this.onSiteChange();
    }
});
